import React from 'react';
import styled from 'styled-components';

import Card from 'antd/es/card';
import Statistics from 'components/Statistics';

const StyledStatsCard = styled(Card)`
  border-radius: 8px;
  border: none;
  background-color: #EFF2F5;

  & .ant-card-body {
    height: 100%;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ant-statistic-title {
    color: #45494D;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    margin: 4px;
  }

  .ant-statistic-content-value {
    display: inline-flex;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #232526;
    vertical-align: middle;
    margin-bottom: 4px;
  }

  .ant-statistic-content-prefix {
    margin-bottom: 8px;
  }
`;

const CartStatCard = ({ stat, background, ...rest }) => {
  const stats = Array.isArray(stat) ? stat : [stat];

  return (
    <StyledStatsCard {...rest}>
      {stats.map((stat, index) => (
        <Statistics
          key={index}
          {...stat}
        />
      ))}
    </StyledStatsCard>
  );
};

export default CartStatCard;